import { useTranslation } from 'react-i18next';
import {
  useCompareVersionTotalPrice,
  useCompareWithVersion,
  useSetCompareWithVersion,
} from '@koob/trip-designer';
import KoobTitle from 'components/Koob/KoobTitle';
import { formatCurrency } from '../../../../utils';
import VersionCompare from './VersionCompare';

// The panel beside the timeline that lays a past version of the trip over it.
export default function ComposeMapCompare({ tripId }) {
  const { t } = useTranslation('tripDesigner');
  const compareWithVersion = useCompareWithVersion();
  const setCompareWithVersion = useSetCompareWithVersion();
  const compareVersionTotalPrice = useCompareVersionTotalPrice();

  return (
    <div className="min-h-0 min-w-0 flex-1 overflow-y-auto bg-gray-50 p-6">
      <div className="flex justify-between items-center">
        <KoobTitle size="text-2xl">
          {t('compose.versions.compareTitle')} {compareWithVersion?.version}
        </KoobTitle>

        <button
          onClick={() => setCompareWithVersion(null)}
          className="border-none text-gray-500 hover:text-gray-700 transition"
        >
          <i className="far fa-times text-lg" />
        </button>
      </div>

      <div
        className="leading-none text-lg text-orange-600 font-semibold"
        data-testid="compare-version-total"
      >
        {compareVersionTotalPrice &&
          t('total', {
            price: formatCurrency({
              amount: compareVersionTotalPrice?.price,
              currency: compareVersionTotalPrice?.currency,
            }),
          })}
      </div>
      <VersionCompare tripId={tripId} />
    </div>
  );
}
